import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-satisfaction1',
    'templateUrl': 'satisfactionPage1.page.html',
    'styleUrls': ['./satisfactionPage1.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class SatisfactionPage1 extends ViewBasePage implements OnInit {
    constructor(injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SATISFACTION_PAGE1);
    }

    public override ngOnInit(): void {
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-satisfaction-1-tour');
    }

    public onNextClick(): void {
        this.router.navigateByUrl('/satisfactionPage2');
    }
}
